import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "bg";
    return localStorage.getItem("pc_lang") || "bg";
  });

  useEffect(() => {
    localStorage.setItem("pc_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const toggle = () => setLang((l) => (l === "bg" ? "en" : "bg"));

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
